import { compose, defaultTo, length, map, prop } from 'ramda';

import { clear } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toBooleanFromProp } from '../../fields/boolean';

const content = (key) => compose(clear, map(prop(key)), defaultTo([]));

const listContent = content('list');
const footnoteContent = content('footnote');

export const listSlice = ({ primary, items }) => {
  const content = listContent(items);
  if (length(content)) {
    return clear({
      type: CommonSliceType.LIST,
      content,
      ordered: toBooleanFromProp('ordered', primary),
    });
  }
};

export const footnoteSlice = ({ items }) => {
  const content = footnoteContent(items);
  if (length(content)) {
    return clear({
      type: CommonSliceType.FOOTNOTE,
      content,
      ordered: true,
    });
  }
};
